import type { Me } from "../api";
import { DeleteWorkspace } from "./DeleteWorkspace";

/**
 * User preferences. Appearance (light/dark) now lives as a sun/moon toggle in the top-right header
 * cluster (next to the bell), so it's one click from anywhere instead of a whole card here. What
 * remains is the account/workspace danger zone (owner-only self-delete). Not operator-only.
 */
export function Preferences({ me }: { me: Me }) {
  return (
    <div className="stack">
      <div className="section-head">
        <h1>Preferences</h1>
      </div>

      <p className="note">
        Appearance (light / dark) is the sun/moon toggle in the top-right, next to your profile.
      </p>

      {/* Owner-only self-delete — renders nothing for non-owners. */}
      <DeleteWorkspace me={me} />
    </div>
  );
}
